import client from "~/apis/client"

export function fetchProperties() {
  return client.get("/properties")
}

export function updateProperty(id, property) {
  return client.patch(`/properties/${id}`, property)
}

export function createProperty(property) {
  return client.post("/properties", property)
}
